export const environments = {
  LocalDev: "LocalDev",
  Development: "Development",
  Test: "Test",
  Staging: "Staging",
  Production: "Production",
};

// Internal Urls
export const baseUrlDevelopment =
  "https://vpr-d-cus-web-1-svc.azurewebsites.net";
export const baseUrlDevelopmentFriendlyName =
  "https://viper-dev.milwaukeetool.com";
export const baseUrlTest = "https://vpr-t-cus-web-1-svc.azurewebsites.net";
export const baseUrlTestEastAsia =
  "https://vpr-t-ea-web-1-svc.azurewebsites.net";
export const baseUrlTestFriendlyName = "https://viper-test.milwaukeetool.com";
export const baseUrlStaging = "https://vpr-s-cus-web-1-svc.azurewebsites.net";
export const baseUrlStagingEastAsia =
  "https://vpr-s-ea-web-1-svc.azurewebsites.net";
export const baseUrlStagingFriendlyName =
  "https://viper-stage.milwaukeetool.com";
export const baseUrlProduction =
  "https://vpr-p-cus-web-1-svc.azurewebsites.net";
export const baseUrlProductionEastAsia =
  "https://vpr-p-ea-web-1-svc.azurewebsites.net";
export const baseUrlProductionFriendlyName = "https://viper.milwaukeetool.com";

export const getEnvironment = () => {
  const hostUrl = window.location.origin.toLowerCase();
  if (isLocalhost(hostUrl)) return environments.LocalDev;

  switch (hostUrl) {
    case baseUrlDevelopment:
    case baseUrlDevelopmentFriendlyName:
      return environments.Development;
    case baseUrlTest:
    case baseUrlTestEastAsia:
    case baseUrlTestFriendlyName:
      return environments.Test;
    case baseUrlStaging:
    case baseUrlStagingEastAsia:
    case baseUrlStagingFriendlyName:
      return environments.Staging;
    case baseUrlProduction:
    case baseUrlProductionEastAsia:
    case baseUrlProductionFriendlyName:
      return environments.Production;
    default:
      return null;
  }
};

const isLocalhost = (hostname) =>
  Boolean(
    hostname.includes("localhost") ||
      // [::1] is the IPv6 localhost address.
      hostname.includes("::1") ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      hostname.includes("127.0.0.1")
  );
